module.exports = __webpack_public_path__ + "static/2-4ef44ddcb7dc0cc90a43b0d09b4089a3.png";